/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import { endOfToday, format, isBefore, parseISO } from 'date-fns';
import Loading from '../../../../components/Loading';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import IMotivo from '../../../../utils/interface/IMotivo';
import CardCadastro from './CardCadastro';
import { ICadastroCobranca } from '..';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { IDependente, IParcelas } from '../../../CartaoSaudeDetalhe';
import { IContaPR } from '../../../../components/Pagamento';
import { formatPrice, formataTelefone } from '../../../../utils/funcoes';
import getResponseErrors from '../../../../utils/getResponseErrors';
import Modal from '../../../../components/Modal';
import Historico from '../../../../components/Historico';
import { IOption } from '../../../../components/SelectSync';

import Formulario, { IRetornoCobranca } from './Formulario';

import Boleto from '../../../../components/Pagamento/Boleto';
import { useAuth } from '../../../../hooks/auth';

// import { Container } from './styles';
interface ICobrancaFormDados {
  CobDataAviso: Date;
  CobMotCodigo: number;
  CobTipo: string;
  CobObservacao: string;
}

export interface IParcela extends IContaPR {
  valorFormatado: string;
  dataVencFormatada: string;
  jurosEmultaFormatado: string;
  valorTotalFormatado: string;
  selecionado: boolean;
}

interface IParcelasEmAberto {
  parcelas: IParcela[];
  totalParcelas: string;
  totalMultaJuros: string;
  totalGeral: string;
}
interface IPlano {
  PlaCodigo: number;
  PlaNumero: string;
  PlaDataInicio: Date;
  PlaInicioFormatado: string;
}

interface ITitular extends IDependente {
  parcelasPagas: number;
}


type Props = {
  dadosCobranca: ICadastroCobranca;
  handleFechar(plaCodigo: number | undefined): void;
};

const Cadastro: React.FC<Props> = ({ dadosCobranca, handleFechar }) => {
  const formRefCadastro = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const { clinica } = useAuth();
  const [loading, setLoading] = useState(false);
  const [optionsMotivo, setOptionsMotivo] = useState<IOption[]>([]);
  const [cobrancas, setCobrancas] = useState<IRetornoCobranca[]>([]);
  const [plano, setPlano] = useState<IPlano | undefined>(undefined);
  const [dependentes, setDependentes] = useState<IDependente[] | undefined>(
    undefined,
  );
  const [titular, setTitular] = useState<ITitular | undefined>(undefined);

  const [parcelas, setParcelas] = useState<IParcelasEmAberto | undefined>(
    undefined,
  );

  const [podeGerarBoleto, setPodeGerarBoleto] = useState(false);

  const [mensagemCancelamento, setMensagemCancelamento] = useState<
    { msg: string; geraMulta: boolean } | undefined
  >(undefined);

  const existeBoleto = useMemo(() => {
    const temBoleto =
      cobrancas.find(cob => cob.parcela && !cob.parcela.CprPago) !== undefined;

    return (
      temBoleto &&
      (clinica.ConfigBoleto?.Emite || clinica.ConfigBoleto?.EmiteOnLine)
    );
  }, [cobrancas, clinica]);

  const [
    showModalHistoricoPacCodigo,
    setShowModalHistoricoPacCodigo,
  ] = useState<number | undefined>(undefined);

  const loadCobrancas = useCallback(
    async (plaCodigo: number): Promise<void> => {
      setLoading(true);
      try {
        const responseMotivo = await api.get<IMotivo[]>(
          `/motivo?MotAtivo=true&MotTipo=3`,
        );

        const responseMulta = await api.get<{ valorMulta: number }>(
          `planos/valormultacancelamento/${plaCodigo}`,
        );

        const motivos = responseMotivo.data.sort((a, b) => {
          // eslint-disable-next-line no-nested-ternary
          return a.MotMotivo < b.MotMotivo
            ? -1
            : a.MotMotivo > b.MotMotivo
              ? 1
              : 0;
        });

        let motivosPermitidos = motivos;
        if (!clinica.AtivaNegociacaoCobranca) motivosPermitidos = motivos.filter(motivo => motivo.MotCodigo !== 400 && motivo.MotCodigo !== 401);


        const options = motivosPermitidos.map((op: IMotivo) => ({
          value: op.MotCodigo.toString(),
          label: op.MotMotivo,
        }));



        setOptionsMotivo(options);
        const response = await api.get(`/planos/${plaCodigo}`);

        const { PlaCodigo, PlaNumero, PlaDataInicio } = response.data;
        const dadosPlano: IPlano = {
          PlaCodigo,
          PlaNumero,
          PlaDataInicio,
          PlaInicioFormatado: format(
            parseISO(PlaDataInicio.toString()),
            'dd/MM/yyyy',
          ),
        };

        setPlano(dadosPlano);

        const retornoCobranca: IRetornoCobranca[] = response.data.cobrancas.map(
          (item: IRetornoCobranca): IRetornoCobranca => {
            const parcelaEncontrada = response.data.parcelas.find(
              (parc: IParcelas) =>
                parc.CprCodigo === item.CobCprCodigoBoleto &&
                parc.CprExcluida === false &&
                parc.CprParcelaAtiva === true,
            );

            const parcela = parcelaEncontrada
              ? {
                ...parcelaEncontrada,
                CprFormaPag: 1,
                CprReceita: 1,
                CprUsuCodigo: 1,
              }
              : undefined;

            return {
              ...item,
              CobDataAvisoFormatada: item.CobDataAviso
                ? format(parseISO(item.CobDataAviso.toString()), 'dd/MM/yyyy')
                : '',
              CobDataFormatada: item.CobData
                ? format(parseISO(item.CobData?.toString()), 'dd/MM/yyyy')
                : '',
              parcela,
            };
          },
        );

        setCobrancas(retornoCobranca);

        const dadosTitular: IDependente[] = response.data.dependentes.filter(
          (dep: IDependente) => dep.DepTitular === true && !dep.DepDataExclusao,
        );

        const parcelasPagas = response.data.parcelas.filter(
          (parc: IContaPR) =>
            parc.CprPago === true && parc.CprParcelaAtiva === true,
        ).length;

        if (dadosTitular[0])
          setTitular({
            ...dadosTitular[0],
            parcelasPagas,
          });

        const parcelasEmAtraso: IParcela[] = response.data.parcelas.filter(
          (parc: IContaPR) =>
            parc.CprPago === false &&
            parc.CprExcluida === false &&
            parc.CprParcelaAtiva === true &&
            isBefore(parseISO(parc.CprDataVenc.toString()), endOfToday()),
        );

        let totalParcelas = 0;
        let totalMultaJuros = 0;
        let totalGeral = 0;

        const parcelasFormatadas = parcelasEmAtraso.map(parc => {
          const multaEjuros = parc.CprJuros + parc.CprMulta;
          const total = multaEjuros + parc.CprValor;
          totalParcelas += parc.CprValor;
          totalMultaJuros += multaEjuros;
          totalGeral += total;

          return {
            ...parc,
            dataVencFormatada: format(
              parseISO(parc.CprDataVenc.toString()),
              'dd/MM/yyyy',
            ),
            valorTotalFormatado: formatPrice(total),
            valorFormatado: formatPrice(parc.CprValor),
            jurosEmultaFormatado: formatPrice(multaEjuros),
            selecionado: true,
          };
        });

        if (responseMulta.data.valorMulta > 0) {
          setMensagemCancelamento({
            msg: `Cartão na fidelidade, o cancelamento irá gerar uma multa de ${formatPrice(
              responseMulta.data.valorMulta,
            )}.`,
            geraMulta: true,
          });
        } else {
          setMensagemCancelamento({
            msg:
              'Cartão fora da fidelidade, cancelamento sem cobrança de multa.',
            geraMulta: false,
          });
        }

        setParcelas({
          parcelas: parcelasFormatadas,
          totalGeral: formatPrice(totalGeral),
          totalMultaJuros: formatPrice(totalMultaJuros),
          totalParcelas: formatPrice(totalParcelas),
        });

        // const parcelasAberto: IParcela[] = response.data.parcelas.filter(
        //   (parc: IContaPR) =>
        //     parc.CprPago === false &&
        //     parc.CprExcluida === false &&
        //     parc.CprParcelaAtiva === true,
        // );

        const dadosDependentes: IDependente[] = response.data.dependentes.filter(
          (dep: IDependente) =>
            dep.DepTitular === false && !dep.DepDataExclusao,
        );

        setDependentes(dadosDependentes);

        const responsavel = dadosDependentes.find(dep => dep.DepResponsavel);

        let temCPF =
          responsavel && responsavel.paciente.PacPessoaFisica
            ? responsavel.paciente.PacCPF !== undefined &&
            responsavel.paciente.PacCPF !== ''
            : responsavel?.paciente.PacCNPJ !== undefined &&
            responsavel?.paciente.PacCNPJ !== '';
        if (!temCPF && dadosTitular[0])
          temCPF = dadosTitular[0].paciente.PacPessoaFisica
            ? dadosTitular[0].paciente.PacCPF !== undefined &&
            dadosTitular[0].paciente.PacCPF !== ''
            : dadosTitular[0]?.paciente.PacCNPJ !== undefined &&
            dadosTitular[0]?.paciente.PacCNPJ !== '';

        setPodeGerarBoleto(temCPF);
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
      setLoading(false);
    },
    [addToast, clinica.AtivaNegociacaoCobranca],
  );

  useEffect(() => {
    if (dadosCobranca) loadCobrancas(dadosCobranca.plaCodigo);
  }, [dadosCobranca, loadCobrancas]);

  const handleOnChange = useCallback(({ value }) => {
    formRefCadastro.current?.setFieldValue('CobObservacao', '');
    if (value) {
      if (value === '20')
        formRefCadastro.current?.setFieldValue(
          'CobObservacao',
          'AVISO DE ATRASO',
        );
      if (value === '22')
        formRefCadastro.current?.setFieldValue(
          'CobObservacao',
          'LEMBRETE DE VENCIMENTO',
        );
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleSubmit = useCallback(
    async (dados: ICobrancaFormDados) => {
      setLoading(true);
      try {
        if (!dadosCobranca)
          addToast({ type: 'error', title: 'Codigo do plano não encontrado' });

        formRefCadastro.current?.setErrors({});
        const schema = Yup.object().shape({
          CobDataAviso: Yup.date().required(),
          CobMotCodigo: Yup.number()
            .typeError('selecione um motivo')
            .required('selecione um motivo'),
          CobTipo: Yup.string().required('selecione um tipo'),
          CobObservacao: Yup.string().required('Adicione uma observação'),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const cobranca = {
          ...dados,
          CobObservacao: dados.CobObservacao.toUpperCase(),
          CobDataAviso: parseISO(`${dados.CobDataAviso.toString()} 12:00:00`),
          CobPlaCodigo: dadosCobranca.plaCodigo,
          CobCprCodigo: dadosCobranca.codigo,
        };

        const novaCobranca = await api.post<IRetornoCobranca>(
          '/cobranca',
          cobranca,
        );

        addToast({ title: 'Cobrança salva', type: 'success' });
        handleFechar(novaCobranca.data.CobPlaCodigo);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRefCadastro.current?.setErrors(errors);
          return;
        }
        const mensagemErro = getResponseErrors(error);
        // const statusErro = error?.response?.status;
        // if (statusErro === 403) {
        //   setExibePermissaoAdmin(true);
        //   setMensagemPermissaoAdmin(mensagemErro);
        // }
        addToast({
          type: 'error',
          title: 'Erro ao salvar cobrança',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [dadosCobranca, addToast, handleFechar],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      {showModalHistoricoPacCodigo !== undefined && (
        <Modal
          show={showModalHistoricoPacCodigo !== undefined}
          titulo="Histórico do Paciente"
          handleFecharModal={() => setShowModalHistoricoPacCodigo(undefined)}
          large
        >
          <Historico pacCodigo={showModalHistoricoPacCodigo} />
        </Modal>
      )}
      <Row>
        <Col xl="4" md="4">
          <CardCadastro title="CARTÃO">
            <b>
              <h4>
                <a
                  href={`/cartaosaudedetalhe/${plano?.PlaCodigo}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {plano?.PlaNumero}
                </a>
              </h4>
            </b>
            <span className="Small">ADESÃO {plano?.PlaInicioFormatado}</span>
          </CardCadastro>
        </Col>
        <Col xl="4" md="4">
          <CardCadastro title="TITULAR">
            {titular && (
              <>
                <b>
                  <a
                    onClick={
                      e => {
                        e.preventDefault();
                        setShowModalHistoricoPacCodigo(
                          titular.paciente.PacCodigo,
                        );
                      }
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                    href=""
                    rel="noreferrer"
                  >
                    {titular.paciente.PacNomeSocial !== ''
                      ? `Nome Social: ${titular.paciente.PacNomeSocial} - ${titular.paciente.PacNome}`
                      : titular.paciente.PacNome}
                  </a>
                </b>
                <br />
                <span style={{ fontSize: 'Smaller' }}>
                  {titular?.paciente.PacTelefone
                    ? `Tel. ${formataTelefone(titular?.paciente.PacTelefone)}`
                    : ''}{' '}
                  {titular?.paciente.PacCelular
                    ? `Cel. ${formataTelefone(titular?.paciente.PacCelular)}`
                    : ''}
                </span>
                <br />
                Total de parcelas pagas: <b>{titular?.parcelasPagas}</b>
              </>
            )}
          </CardCadastro>
        </Col>
        <Col xl="4" md="4">
          {dependentes && dependentes.length > 0 && (
            <CardCadastro title="DEPENDENTES">
              {dependentes.map(dep => (
                <div
                  key={`dep-${dep.DepCodigo}-${dep.DepPlaCodigo}`}
                  className={dep.DepResponsavel ? 'text-danger' : ''}
                >
                  {dep.DepResponsavel ? <b>RESPONSÁVEL: </b> : ''}
                  <b>
                    <a
                      onClick={
                        e => {
                          e.preventDefault();
                          setShowModalHistoricoPacCodigo(
                            dep.paciente.PacCodigo,
                          );
                        }
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                      href=""
                      rel="noreferrer"
                    >
                      {dep.paciente.PacNomeSocial !== ''
                        ? `Nome Social: ${dep.paciente.PacNomeSocial} - ${dep.paciente.PacNome}`
                        : dep.paciente.PacNome}
                    </a>
                  </b>
                  <br />
                  <span style={{ fontSize: 'Smaller' }}>
                    {dep?.paciente.PacTelefone
                      ? `Tel. ${formataTelefone(dep?.paciente.PacTelefone)}`
                      : ''}{' '}
                    {dep?.paciente.PacCelular
                      ? `Cel. ${formataTelefone(dep?.paciente.PacCelular)}`
                      : ''}
                  </span>
                  <br />
                </div>
              ))}
            </CardCadastro>
          )}
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <CardCadastro title="NEGOCIAÇÕES ANTERIORES">
            <div
              style={{ maxHeight: '114px', overflowY: 'auto', margin: '-15px' }}
            >
              {cobrancas && cobrancas.length > 0 && (
                <table
                  className="table table-hover table-sm small"
                  cellSpacing="0"
                  cellPadding="4"
                  style={{ borderCollapse: 'collapse', fontFamily: 'verdana' }}
                >
                  <tbody>
                    <tr className="bg-light text-info small">
                      <th scope="col">Dt. Contato</th>
                      <th scope="col">Colaborador</th>
                      <th scope="col">Resposta do Cliente</th>
                      <th scope="col">dt. Novo Contato</th>
                      <th> - </th>
                    </tr>
                    {cobrancas.map(item => (
                      <tr
                        key={`cobItem-${item.CobCodigo}`}
                        style={{ fontSize: 'Smaller' }}
                      >
                        <td style={{ width: '85px' }}>
                          {item.CobDataFormatada}
                        </td>
                        <td>{item.CobUsuNome}</td>
                        <td>{item.CobObservacao}</td>
                        <td style={{ width: '110px' }}>
                          {item.CobDataAvisoFormatada}
                        </td>
                        <td>
                          {item.parcela && !item.parcela?.CprPago && (
                            <>
                              <div className="d-flex justify-content-end">
                                <Boleto
                                  cprCodigo={item.CobCprCodigoBoleto}
                                  contaPR={item.parcela}
                                  inLine
                                />
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </CardCadastro>
        </Col>
      </Row>
      {mensagemCancelamento?.geraMulta && (
        <div className="alert alert-warning p-3 mt-2">
          {mensagemCancelamento.msg}
        </div>
      )}

      {mensagemCancelamento && !mensagemCancelamento.geraMulta && (
        <div className="alert alert-primary p-3 mt-2">
          {mensagemCancelamento.msg}
        </div>
      )}
      <Row>
        <Col>
          <CardCadastro title="PARCELAS EM ATRASO">
            <div
              style={{ maxHeight: '114px', overflowY: 'auto', margin: '-15px' }}
            >
              {parcelas && parcelas.parcelas.length > 0 && (
                <table
                  className="table table-hover table-sm small"
                  cellSpacing="0"
                  cellPadding="4"
                  style={{ borderCollapse: 'collapse', fontFamily: 'verdana' }}
                >
                  <tbody>
                    <tr className="bg-light text-info small">
                      <th scope="col">Histórico</th>
                      <th scope="col">Data Venc.</th>
                      <th scope="col">Valor</th>
                      <th scope="col">M+J</th>
                      <th scope="col">Total</th>
                    </tr>
                    {parcelas.parcelas.map(item => (
                      <tr
                        key={`cobItem-${item.CprCodigo}`}
                        style={{ fontSize: 'Smaller' }}
                      >
                        <td>{item.CprHistorico}</td>
                        <td>{item.dataVencFormatada}</td>
                        <td>{item.valorFormatado}</td>
                        <td style={{ width: '110px' }}>
                          {item.jurosEmultaFormatado}
                        </td>
                        <td style={{ width: '110px' }}>
                          {item.valorTotalFormatado}
                        </td>
                      </tr>
                    ))}
                    <tr key="cobItem-total" style={{ fontSize: 'Smaller' }}>
                      <td />
                      <td>
                        <b>Total:</b>
                      </td>
                      <td>{parcelas.totalParcelas}</td>
                      <td style={{ width: '110px' }}>
                        {parcelas.totalMultaJuros}
                      </td>
                      <td style={{ width: '110px' }}>{parcelas.totalGeral}</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </CardCadastro>
        </Col>
      </Row>
      {/* <br />
      <Row>
        <Col>
          <CardCadastro title="NOVA NEGOCIAÇÃO">
            <div
              className="text-left"
              style={{ fontSize: '.8rem', margin: '-10px' }}
            >
              <Form
                ref={formRefCadastro}
                initialData={{
                  CobTipo: 'WhatsApp',
                  CobDataAviso: format(new Date(), 'yyy-MM-dd'),
                }}
                onSubmit={handleSubmit}
              >
                <Row>
                  <Col md="6" lg="6" className="form-group pr-2">
                    <SelectSync
                      name="CobMotCodigo"
                      label="Motivo"
                      placeholder="Selecione"
                      isClearable={false}
                      handleSelectChange={handleOnChange}
                      options={optionsMotivo || [{ label: '', value: '' }]}
                    />
                  </Col>
                  <Col md="3" lg="3" className="form-group pr-2">
                    <SelectSync
                      name="CobTipo"
                      label="Tipo"
                      placeholder="Selecione"
                      isClearable={false}
                      handleSelectChange={handleOnChangeVazio}
                      options={[
                        { label: 'Telefone', value: 'Telefone' },
                        { label: 'E-mail', value: 'E-mail' },
                        { label: 'WhatsApp', value: 'WhatsApp' },
                      ]}
                    />
                  </Col>
                  <Col md={3} lg={3}>
                    <Input
                      name="CobDataAviso"
                      label="Data"
                      type="date"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="9" lg="9" className="form-group pr-2">
                    <TextArea
                      name="CobObservacao"
                      label="Observação"
                      rows={3}
                    />
                  </Col>
                  <Col md={3} lg={3} className="form-group pr-2">
                    <Button type="submit" className="mt-5">
                      Salvar
                    </Button>
                  </Col>{' '}
                </Row>
              </Form>
            </div>
          </CardCadastro>
        </Col>
      </Row> */}
      <br />
      <Row>
        <Col>
          <CardCadastro title="NOVA NEGOCIAÇÃO">
            <div
              className="text-left"
              style={{ fontSize: '.8rem', margin: '-10px' }}
            >
              {/* {parcelas && parcelas.parcelas.length > 0 && ( */}
              <Formulario
                handleFechar={handleFechar}
                dadosCobranca={dadosCobranca}
                optionsMotivo={optionsMotivo}
                parcelas={parcelas?.parcelas}
                atualizaDadosCobranca={loadCobrancas}
                temBoleto={existeBoleto}
                podeGerarBoleto={podeGerarBoleto}
                negociacaoAtiva={clinica?.AtivaNegociacaoCobranca || false}
              />
              {/* )} */}
            </div>
          </CardCadastro>
        </Col>
      </Row>
    </>
  );
};

export default Cadastro;
